import { ShimmerMetricRow } from "./DashboardShimmer";
import AverageWeights from "./AverageWeights";
import LossMetrics from "./LossMetrics";
import "./dashboard-sections.css";
import DashboardSummaryBox from "./DashboardSummaryBox";
import SlickSlider from "../../slider/SlickSlider";

const DUMMY = {
  total_paid_cases:  12450,
  total_paid_kg:     249000,
  total_orange_kg:   184200,
  total_ripened_kg:  58600,
  total_rejected_kg: 4120,
};

const SlickArrow = ({ direction, onClick }) => (
  <button
    type="button"
    className={`db-slick-arrow db-slick-${direction}`}
    onClick={onClick}
    aria-label={direction === "prev" ? "Previous" : "Next"}
  >
    {direction === "prev" ? (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    ) : (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    )}
  </button>
);

const FreshFruitRunningTotals = ({ data = DUMMY, isLoading = false }) => {
  const metrics = [
    { label: "Total Paid Cases",  value: data.total_paid_cases?.toLocaleString(),  unit: "",   badge: "+4%" },
    { label: "Total Paid KG",     value: data.total_paid_kg?.toLocaleString(),     unit: "kg"  },
    { label: "Total Orange KG",   value: data.total_orange_kg?.toLocaleString(),   unit: "kg"  },
    { label: "Total Ripened KG",  value: data.total_ripened_kg?.toLocaleString(),  unit: "kg"  },
    { label: "Total Rejected KG", value: data.total_rejected_kg?.toLocaleString(), unit: "",   danger: true, dot: true },
    { label: "Total Rejected KG", value: data.total_rejected_kg?.toLocaleString(), unit: "",   danger: true, dot: true },
  ];

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    draggable: true,
    nextArrow: <SlickArrow direction="next" />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 768,  settings: { slidesToShow: 2 } },
      { breakpoint: 480,  settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="db-section">
      {/* ── Slider at top ── */}
      {isLoading ? (
        <ShimmerMetricRow count={5} />
      ) : (
        <div className="db-slick-wrapper mb-3">
          <SlickSlider settings={slickSettings}>
            {metrics.map((item, i) => (
              <div key={`${item.label}-${i}`} className="db-slick-slide">
                <DashboardSummaryBox data={item} />
              </div>
            ))}
          </SlickSlider>
        </div>
      )}

      {/* Sub-sections inside Fresh Fruit Running Totals */}
      <div className="db-subsections">
        <AverageWeights isLoading={isLoading} />
        <LossMetrics isLoading={isLoading} />
      </div>
    </div>
  );
};

export default FreshFruitRunningTotals;
